import { CoordinateType, IStroke } from '../components/SVG';
import { areaDataValueIndex } from '../const';

import { IModifiedBets, ISquareRect } from './types';

export const commonStroke: IStroke = {
  color: '#000',
  strokeWidth: 3,
};

export const calculateCoordinate = (
  offset: number,
  index: number,
  startPosition: number,
  correction: number = 0,
) => (index === 0 ? startPosition : startPosition + index * offset + correction * index);

export const betOffset = 77.7;

export const calculateCurrentY = (rowIndex: number, isWide: boolean): number =>
  rowIndex === 0 ? 1 : rowIndex * (isWide ? 68.8 : 78.8) - rowIndex;

export const getStartCoordinates = (
  offset: number,
  index: number,
  startPosition: number,
  currentY: number,
  correction: number = 0,
): [number, number] => {
  const currentX: number = calculateCoordinate(offset, index, startPosition, correction);
  return [currentX, currentY];
};

// @ts-ignore
export const calculateIndexes = (num: string): number[] => areaDataValueIndex[num];

export const complexBetStartX = 1002.2;

export const complexBetSize: CoordinateType = [128.8, betOffset];

export const complexBetSizeWide: CoordinateType = [78.8, betOffset - 10];

export const dozensOffset = 310.7;

export const chancesOffset = 155.4;

export const wideProportion = 1.32;

export const dozensRectSettings: ISquareRect = { size: [310.7, 60.1], start: [70, 233.4] };

export const dozensRectSettingsWide: ISquareRect = {
  size: [310.7 / wideProportion, 60.1],
  start: [70, 233.4],
};

export const chancesRectSettings: ISquareRect = { start: [70, 293], size: [155.4, 60.1] };

export const chancesRectSettingsWide: ISquareRect = {
  size: [155.4 / wideProportion, 60.1],
  start: [70, 293],
};

export enum Filters {
  winner = 'winner',
}

export const calcultateModifiers = (selector: string, { selected, winners }: IModifiedBets) => ({
  selected: selected.has(selector),
  isWin: winners.has(selector),
});
